import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Send_message from "../../common-components/common-btn/send_message/Send_message";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import Full_screen_modal from "../../common-components/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../../lotties/success_lottie/Success_lottie";
import "./Contact.css";
import classNames from "classnames";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";

const Contacts = () => {
  const [formSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "isramitb@gmail.com",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
          window.scrollTo({
            top: 0,
            behavior: "auto",
          });
        }, 3000);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <section className="contact_section ">
      <div className="container">
        <Heading_title
          title={"Contact Us"}
          subtitle={
            "Connect with us to start your sports and fitness journey today"
          }
        />
        <div className="contact_grid">
          <div className="contact_info">
            <div className="info_card">
              <img
                src="/assets/images/icons/contact/address1.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_holder">
                <div className="info_content">
                  <h6 className="info_label">Address</h6>
                  <p className="info_text">Swami Vivekanand Sports Club, LMD Chowk, Bavdhan & Ganga Legend Sports Ground, Bavdhan</p>
                </div>


                <div className="icon_circle">
                  <img
                    src="/assets/images/icons/contact/address.png"
                    alt="Location"
                    className="info_icon_img"
                  />
                </div>
              </div>
            </div>

            <div className="info_card">
              <img
                src="/assets/images/icons/contact/phone1.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_holder">
                <div className="info_content">
                  <h6 className="info_label">Phone Number</h6>
                  <p className="info_text">+91 9096247296</p>
                </div>
                <div className="icon_circle">
                  <img
                    src="/assets/images/icons/contact/phone.png"
                    alt="Phone"
                    className="info_icon_img"
                  />
                </div>
              </div>
            </div>

            <div className="info_card">
              <img
                src="/assets/images/icons/contact/mail1.png"
                alt=""
                className="bg_icon"
              />
              <div className="info_holder">
                <div className="info_content">
                  <h6 className="info_label">Email</h6>
                  <p className="info_text">isramitb@gmail.com</p>
                </div>
                <div className="icon_circle">
                  <img
                    src="/assets/images/icons/contact/email.png"
                    alt="Email"
                    className="info_icon_img"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="contact_form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Full Name*"
                  {...register("name", {
                    required: "Name is required",
                  })}
                  className={classNames("contact_input", {
                    "is-valid": getValues("name"),
                  })}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Control
                  type="text"
                  name="email"
                  placeholder="Enter Email*"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("contact_input", {
                    "is-invalid": errors?.email,
                    "is-valid": getValues("email"),
                  })}
                />
                {errors?.email && (
                  <span className="invalid-feedback d-block">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Control
                  as={"textarea"}
                  type="text"
                  name="message"
                  placeholder="Write your message here"
                  {...register("message", {
                    required: "Message is required",
                  })}
                  className={classNames("contact_input", {
                    "is-invalid": errors?.message,
                    "is-valid": getValues("message"),
                  })}
                />
                {errors?.message && (
                  <span className="invalid-feedback d-block">
                    {errors.message.message}
                  </span>
                )}
              </Form.Group>
              {!formSubmitted && <Send_message type="submit" />}
            </Form>
          </div>
        </div>
      </div>

      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_lottie />}
      />
    </section>
  );
};

export default Contacts;
